export const formatCentsToDollars = (cents?: number, opts?: { whole?: boolean }): string => {
  if (cents == null || isNaN(cents)) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    // Whole-dollar readout for large $ figures (e.g. UPB / purchase price):
    // cents are noise against millions and force the value to wrap. Percent
    // price keeps its decimals — it's formatted elsewhere, not here.
    ...(opts?.whole ? { maximumFractionDigits: 0 } : {}),
  }).format(cents / 100);
};

export const toPercentage = (bps?: number): string => {
  if (bps == null || isNaN(bps)) return '-';
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumSignificantDigits: 1,
  }).format(bps / 10000);
};
